<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading">
	<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
<div class="layout-container" *ngIf="!loading">
	<form [formGroup]="voucherForm" (ngSubmit)="this.paymentMode === 'voucherCode' ? onAddVoucherControl() : ''">
		<ng-container *ngIf="this.paymentMode === 'voucherCode'">
			<div class="row mx-0 justify-content-between mb-2">
				<div class="col-auto px-0">
					<span class="fs-20px fw-500 d-block">{{ locale.translations['payment']['n600'] }}</span>
				</div>
				<div
					class="col-auto px-0 d-flex align-items-center"
					[ngClass]="{ 'text-start': locale.lang !== 'en', 'text-end': locale.lang === 'en' }"
					(click)="onOpenWhatsapp()"
				>
					<img [src]="'/assets/images/payment/whatsapp.svg' | s3Image" [ngClass]="{ 'me-2': locale.lang === 'en', 'ms-2': locale.lang !== 'en' }" />
					<span class="help">{{ locale.translations['whats-new']['new-auth']['n572'] }}</span>
				</div>
			</div>

			<span class="fg-light-grey d-block mb-12px">{{ locale.translations['payment']['n601'] }}</span>
			<div class="mdc-layout-grid__inner" [ngClass]="{ 'margin-bottom-5em': embedded }">
				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<div class="mdc-layout-grid__inner">
						<div class="mdc-layout-grid__cell--span-8-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-2-phone">
							<mat-form-field appearance="outline" hideRequiredMarker class="update-padding">
								<input matInput type="text" #inputValue (keyup)="onKeyUp('voucherCodeValue', voucherForm)" formControlName="voucherCodeValue" />

								<mat-error
									*ngIf="
										voucherForm.get('voucherCodeValue') &&
										voucherForm.get('voucherCodeValue').touched &&
										voucherForm.get('voucherCodeValue').invalid
									"
								>
									{{ getErrorMessage('voucherCodeValue', locale.translations['payment']['n212']) }}
								</mat-error>
							</mat-form-field>
						</div>

						<div
							class="mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
							[ngClass]="{ 'text-end': locale.lang === 'en', 'text-start': locale.lang !== 'en' }"
						>
							<button mat-flat-button class="btn add-voucher mt-1 fs-14px" color="primary" type="submit" [disabled]="vouchers.length === 3">
								<mat-icon
									class="add-icn"
									[ngClass]="{ 'me-2': locale.lang === 'en', 'ms-2': locale.lang !== 'en' }"
									style="vertical-align: middle"
								>
									add
								</mat-icon>
								<span class="voucher-btn fw-400">{{ locale.translations['payment']['n623'] | titlecase }}</span>
							</button>
						</div>

						<div class="mdc-layout-grid__cell--span-12 custom-alignment">
							<mat-form-field appearance="outline" *ngFor="let voucher of vouchers; let i = index" hideRequiredMarker class="voucher-padding">
								<input matInput type="text" [formControlName]="voucher" />
								<button (click)="onDeleteVoucher(voucher, i)" matSuffix mat-icon-button aria-label="Clear">
									<img [src]="'/assets/images/payment/delete-img.svg' | s3Image" class="delete-image" />
								</button>
							</mat-form-field>
						</div>
					</div>

					<div
						class="mdc-layout-grid__inner desktop-style mb-3 mt-10px"
						[ngClass]="{
							'mt-3':
								(voucherForm.get('voucherCodeValue') &&
									voucherForm.get('voucherCodeValue').touched &&
									voucherForm.get('voucherCodeValue').invalid) ||
								vouchers.length > 0
						}"
					>
						<div class="mdc-layout-grid__cell--span-12 p-3 info-box">
							<mat-icon class="fg-light-grey align-middle fs-20px">info</mat-icon>
							<p class="fs-14px mb-0">
								{{ locale.translations['payment']['n604'] }}
								<span class="fw-500">
									{{ package === 'vip' ? locale.translations['payment']['n223'] : locale.translations['payment']['n222'] }}
								</span>
							</p>
						</div>
					</div>

					<img [src]="'/assets/images/payment/scratch-card.svg' | s3Image" class="payment-img" />
					<span class="fg-light-grey fs-11px d-flex justify-content-center">{{ locale.translations['payment']['n603'] }}</span>
				</div>
			</div>
		</ng-container>

		<ng-container *ngIf="this.paymentMode === 'mobileBalance'">
			<ng-container *ngIf="step === 1">
				<div class="mdc-layout-grid__inner" [ngClass]="{ 'margin-bottom-5em': embedded }">
					<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
						<div class="row mx-0 justify-content-between">
							<div class="col-auto px-0">
								<span class="fs-20px fw-500">{{ locale.translations['payment']['n605'] }}</span>
							</div>
							<div
								class="col-auto px-0 d-flex align-items-center"
								[ngClass]="{ 'text-start': locale.lang !== 'en', 'text-end': locale.lang === 'en' }"
								(click)="onOpenWhatsapp()"
							>
								<img [src]="'/assets/images/payment/whatsapp.svg' | s3Image" [ngClass]="{ 'me-2': locale.lang === 'en', 'ms-2': locale.lang !== 'en' }" />
								<span class="help">{{ locale.translations['whats-new']['new-auth']['n572'] }}</span>
							</div>
						</div>

						<!-- blue box -->
						<div class="box my-3 blue" *ngIf="viewport.type !== 'mobile'">
							<div class="icon">
								<mat-icon class="fs-18px mat-icon-rtl-mirror text-center" [ngClass]="{ 'ms-2': locale.lang !== 'en' }">computer</mat-icon>
							</div>
							<p class="fs-14px mb-0 blue fw-500">
								{{ locale.translations['payment']['n629'] }}:
								<span class="fw-400">
									<span class="fw-400">{{ locale.translations['payment']['n630'] }}</span>
								</span>
							</p>
						</div>

						<div class="mdc-layout-grid__inner mb-3">
							<div class="mdc-layout-grid__cell--span-12">
								<h3 class="mb-0 font-weight-semi-bold">{{ locale.translations['payment']['n606'] }}</h3>
								<span class="fg-grey">{{ locale.translations['payment']['n628'] }}</span>
								<img
									class="mt-1 img-fluid"
									[src]="
										provider === 'asiacell' && package === 'vip'
											? '/assets/images/payment/guide-image-1-asiacell-vip.svg'
											: provider === 'korek' && package === 'vip'
											? '/assets/images/payment/guide-image-1-korek-vip.svg'
											: provider === 'asiacell' && package === 'basic'
											? '/assets/images/payment/guide-image-1-asiacell-basic.svg'
											: '/assets/images/payment/guide-image-1-korek-basic.svg' | s3Image
									"
								/>
							</div>
						</div>

						<div class="mdc-layout-grid__inner">
							<div class="mdc-layout-grid__cell--span-12">
								<h3 class="mb-0 font-weight-semi-bold">{{ locale.translations['payment']['n608'] }}</h3>
								<span class="fg-grey">{{ locale.translations['payment']['n609'] }}</span>
								<img
									class="mt-1 img-fluid"
									[src]="
										provider === 'asiacell' && package === 'vip'
											? '/assets/images/payment/guide-image-2-asiacell-vip.svg'
											: provider === 'korek' && package === 'vip'
											? '/assets/images/payment/guide-image-2-korek-vip.svg'
											: provider === 'asiacell' && package === 'basic'
											? '/assets/images/payment/guide-image-2-asiacell-basic.svg'
											: '/assets/images/payment/guide-image-2-korek-basic.svg' | s3Image
									"
								/>
							</div>
						</div>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="step === 2">
				<div class="mdc-layout-grid__inner" [ngClass]="{ 'margin-bottom-5em': embedded }">
					<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
						<div class="row mx-0 justify-content-between mb-3">
							<div class="col-auto px-0">
								<span class="fs-20px fw-500">{{ locale.translations['payment']['n593'] }}</span>
							</div>
							<div
								class="col-auto px-0 d-flex align-items-center"
								[ngClass]="{ 'text-start': locale.lang !== 'en', 'text-end': locale.lang === 'en' }"
								(click)="onOpenWhatsapp()"
							>
								<img [src]="'/assets/images/payment/whatsapp.svg' | s3Image" [ngClass]="{ 'me-2': locale.lang === 'en', 'ms-2': locale.lang !== 'en' }" />
								<span class="help">{{ locale.translations['whats-new']['new-auth']['n572'] }}</span>
							</div>
						</div>

						<span class="fg-grey d-block">
							{{ locale.translations['payment']['n611'] }}
							{{ provider === 'asiacell' ? locale.translations['payment']['n466'] : locale.translations['payment']['n467'] }}
							{{ locale.translations['payment']['n612'] }}
						</span>

						<div class="row mx-0">
							<div class="col-12 px-0 mt-1 mb-3 desktop-style px-3 py-2">
								<span class="fw-500">{{ provider === 'asiacell' ? asiaCellData.phone : korekData.phone }}</span>
							</div>
						</div>

						<div class="row mx-0 py-3 px-2 text-center" [ngClass]="{ 'dark-grey-style': viewport.type !== 'mobile' }">
							<span class="fs-20px text-center" [dir]="'ltr'">
								{{
									provider === 'asiacell' && package === 'vip'
										? asiaCellData.upgradeToVip
										: provider === 'korek' && package === 'vip'
										? korekData.upgradeToVip
										: provider === 'asiacell' && package === 'basic'
										? asiaCellData.upgradeToBasic
										: korekData.upgradeToBasic
								}}
							</span>
						</div>

						<!-- blue box -->
						<div class="box my-3 blue" *ngIf="viewport.type !== 'mobile'">
							<div class="icon">
								<mat-icon class="fs-18px mat-icon-rtl-mirror text-center">computer</mat-icon>
							</div>
							<p class="fs-14px mb-0 blue fw-500">
								{{ locale.translations['payment']['n629'] }}:
								<span class="fw-400">
									{{ locale.translations['payment']['n631'] }}
								</span>
							</p>
						</div>

						<button
							mat-flat-button
							type="button"
							class="checkout-btn w-100 mb-2 fw-400"
							color="primary"
							(click)="onCall()"
							*ngIf="viewport.type === 'mobile'"
						>
							<mat-icon class="mat-icon-rtl-mirror arrow-btn fw-400 mx-2">phone</mat-icon>
							{{ locale.translations['payment']['n613'] }}
						</button>

						<button
							mat-stroked-button
							type="button"
							class="checkout-btn w-100 fw-400"
							color="primary"
							(click)="onCopyToClipboard()"
							*ngIf="viewport.type === 'mobile'"
						>
							<img class="clipboard" [src]="'assets/favicon/copy-filled.svg' | s3Image" alt="download" />
							{{ locale.translations['payment']['n614'] }}
						</button>
					</div>
				</div>
			</ng-container>
		</ng-container>

		<div class="button-container d-flex justify-content-between">
			<button mat-stroked-button type="button" class="checkout-btn w-100 fw-400" color="primary" (click)="onBack()">
				<mat-icon class="mat-icon-rtl-mirror arrow-btn mx-2">arrow_back</mat-icon>
				{{ locale.translations['payment']['n622'] }}
			</button>

			<button
				*ngIf="step !== 2"
				mat-flat-button
				type="button "
				class="checkout-btn fw-400 w-100 ms-16px"
				color="primary"
				[disabled]="this.paymentMode === 'voucherCode' ? vouchers.length < 1 || loading : loading"
				(click)="this.paymentMode === 'voucherCode' ? onVoucher() : onNext()"
			>
				{{ locale.translations['whats-new']['default']['n436'] }}
				<mat-icon class="mat-icon-rtl-mirror arrow-btn fg-light-grey mx-2">arrow_forward</mat-icon>
			</button>

			<button
				*ngIf="step === 2"
				mat-flat-button
				[disabled]="viewport.type === 'mobile' ? !isPaymentEnabled : !voucherForm"
				type="button"
				class="checkout-btn w-100 ms-16px fw-400"
				color="primary"
				(click)="onMobileBalance()"
			>
				{{ locale.translations['payment']['n602'] }}
			</button>
		</div>
	</form>
</div>
